import type { WorkflowStage } from '@/types'

export const WORKFLOW_STAGE_DEFAULT_COLOR = '#07B2AF'

export const WORKFLOW_STAGE_DEFAULT_MODEL: Omit<
  WorkflowStage,
  'id' | 'workflow_id'
> = {
  color: WORKFLOW_STAGE_DEFAULT_COLOR,
  name: '',
  description: '',
  allow_publish: false,
  allow_admin_publish: false,
  after_publish_id: undefined,
  story_editing_locked: false,
  allow_all_stages: true,
  workflow_stage_ids: [],
  allow_all_users: true,
  position: 0,
  is_default: false,
  allow_editor_change: false,
  allow_admin_change: false,
  user_ids: [],
  space_role_ids: [],
  _new: false,
  _destroy: false,
}

export const WORKFLOW_STAGES_DEFAULT_LIST = [
  {
    ...WORKFLOW_STAGE_DEFAULT_MODEL,
    name: 'Drafting',
    color: '#babcb6',
  },
  {
    ...WORKFLOW_STAGE_DEFAULT_MODEL,
    name: 'Reviewing',
    color: '#ffcc12',
  },
  {
    ...WORKFLOW_STAGE_DEFAULT_MODEL,
    name: 'Ready to Publish',
    color: '#1bb300',
    allow_publish: true,
  },
]

export const NONE_WORKFLOW_STAGE = {
  ...WORKFLOW_STAGE_DEFAULT_MODEL,
  name: 'None',
  color: '#c3c7cd',
  id: 0,
}

export const WORKFLOW_DEFAULT_MODEL = {
  name: '',
  content_types: [],
  workflow_stages: WORKFLOW_STAGES_DEFAULT_LIST,
}

export enum WORKFLOWS_LOADING_STATE_TYPES {
  WORKFLOWS = 'workflows',
  STAGES = 'stages',
}

export const WORKFLOW_STAGE_COLOR_MAX_LENGTH = 7
export const WORKFLOW_STAGE_NAME_MAX_LENGTH = 20
export const WORKFLOW_STAGE_LIST_ITEM_LABEL_MAX_LENGTH = 45
export const WORKFLOW_STAGE_LIST_ITEM_STAGES_MAX_LENGTH = 2

export enum WorkflowStageActions {
  Create = 'Create',
  Edit = 'Edit',
  Delete = 'Delete',
}
